import React from "react";
import styles from "./css/EntityInfoSection.module.css";
import { CityData, OfficeData, Project, CreateProjectData } from "@/types";
import { formatDateWithTime } from "@/utils/date";
import { isCityData } from "@/utils/typeGuards";

interface EntityInfoSectionProps {
    entity: CityData | OfficeData;
    cardMode?: boolean;
    project?: Project | CreateProjectData;
    project_type?: boolean;
}

export const EntityInfoSection: React.FC<EntityInfoSectionProps> = ({ entity, cardMode = false, project, project_type = false }) => {
    return (
        <div className={`${styles.cityInformation} ${cardMode ? styles.cityInformationCard : ""}`}>
        <img className={`${cardMode ? styles.cityLogoCard : project ? styles.cityLogoProject : styles.cityLogo}`} src={entity?.logo} alt="cityLogo" />
          <div className={styles.cityContent}>
              <div className={styles.cityName}>{entity?.name}</div>
              {project_type && project && <div className={styles.projectName}>{project.name}</div>}
              <div className={`${cardMode ? styles.cityDescriptionCard : styles.cityDescription}`}>
                {isCityData(entity) && (
                  <>
                  {!project && <div>
                    <div className={styles.bold}>{entity.projects}</div>
                    {' '}פרוייקטים{' '}
                  </div>}
                  <div>
                    <div className={styles.bold}>
                          {formatDateWithTime(project_type && project? (project as Project).last_updated : entity.last_files_update)}
                    </div>
                    {' '}עדכון קבצים אחרון
                  </div>
                  </>
                )}
              </div>
          </div>
      </div>
    );
}